// Loads a list for a payroll screen. A failed load is reported as a failure, never as an empty list: an empty
// list on screen reads as "nothing is owed", which is a different statement from "we could not look"
// (triage FE-06-27).
export async function loadList(fetchList, pick, failureMessage) {
  try {
    const res = await fetchList();
    return { items: pick(res) || [], error: "" };
  } catch {
    return { items: [], error: failureMessage };
  }
}
